import getConfig from 'next/config';
import { useEffect } from 'react';
import makeZapierRequestsRelative from '../utils/makeZapierRequestsRelative';

/**
 * If the MAKE_ZAPIER_REQUESTS_RELATIVE env variable is truthy,
 * monkey patch window.fetch to strip https://zapier.com from HTTP
 * requests. This works around an issue loading private services.
 * See `makeZapierRequestsRelative` for more info.
 *
 * Only runs client side.
 */
export default function useMakeZapierRequestsRelative() {
  useEffect(() => {
    const { publicRuntimeConfig } = getConfig();
    if (publicRuntimeConfig.shouldMakeZapierRequestsRelative) {
      makeZapierRequestsRelative();
    }
  }, []);
}
